import { useUserStore } from '../stores/use-user-store';

export const ROLES = { ORGANIZATION: 'organization', ENGINEER: 'engineer' };

/** Организация "Меридиан" — единственная, у кого есть доступ к служебным разделам */
export const MERIDIAN_ORG_ID = 1;

const ROLE_NAMES = {
  [ROLES.ORGANIZATION]: 'Организация',
  [ROLES.ENGINEER]: 'Инженер',
};

export const getRoleName = (role) => {
  return role && role in ROLE_NAMES ? ROLE_NAMES[role] : ROLE_NAMES[ROLES.ORGANIZATION];
};

const useGetRole = () => {
  const { user } = useUserStore();
  const role = user?.role ?? ROLES.ORGANIZATION;
  const roleName = getRoleName(role);
  const isEngineer = role === ROLES.ENGINEER;
  const isMeridianOrg = user?.org_id === MERIDIAN_ORG_ID;
  return { role, roleName, isEngineer, isMeridianOrg };
};

export default useGetRole;
